import Axios from "../../../Lib/Axios";
import Endpoint from "../../../Config/Endpoint";

export const fetchMenuList = async () => {

    try {
        return await Axios.get(Endpoint.Menu, {loading: false}).then(function (response) {
           return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}

export const fetchMovieByAlias = async (alias, params = '', page = 1) => {

    try {

        return await Axios.get(Endpoint.category.movieByCategory+alias+"/"+page, {params}).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}
